// MUI
import { Stack } from "@mui/material";

// Components
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

interface IGetChangeRequestCustomHeader {
	defaultSwitchValue: string | undefined;
	checked: boolean;
	handleSwitchChange: (value: boolean) => void;
	showPositionsSelector: boolean | undefined;
	selectedPositions: { label: string }[];
	positions: { label: string }[];
	handlePositionsChange: (newPositions: { label: string }[]) => void;
}

export const ChangeRequestsTableHeader = ({
	defaultSwitchValue,
	checked,
	handleSwitchChange,
	showPositionsSelector,
	selectedPositions,
	positions,
	handlePositionsChange,
}: Readonly<IGetChangeRequestCustomHeader>) => (
	<Stack direction="row" spacing={1}>
		{defaultSwitchValue && (
			<CustomizedSwitches
				className="max-w-[250px]"
				textRight={true}
				textChecked={`Show only ${defaultSwitchValue?.toLowerCase()} change requests`}
				textUnChecked={`Show only ${defaultSwitchValue?.toLowerCase()} change requests`}
				checked={checked}
				onChange={handleSwitchChange}
			/>
		)}
		{showPositionsSelector && (
			<SmartSelector
				multiple
				tagsVariant={"text"}
				selectBy={"label"}
				showBy={"label"}
				options={positions}
				selected={selectedPositions}
				inputProps={{
					placeholder: "Position(s)",
				}}
				listBoxProps={{
					sx: { maxHeight: "220px" },
				}}
				sx={{ width: "256px" }}
				onChangeAction={(values) => handlePositionsChange(values as { label: string }[])}
			/>
		)}
	</Stack>
);
